import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b9b9cf9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = { class: "statistics" }
const _hoisted_3 = { class: "ws_ml16" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "current" }
const _hoisted_6 = { class: "ws_ml5" }
const _hoisted_7 = { class: "before" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "tip" }, null, -1))
const _hoisted_9 = { class: "echarts ws_mt16" }
const _hoisted_10 = { class: "map" }
const _hoisted_11 = { class: "bar-echarts" }

import { ref } from 'vue'
import DeviceStatistice from './components/device-statistics.vue'
import CustomerMap from './components/customer-map.vue'
import { queryStaticsDeviceSummary } from '@/api'
import { CODE_ENUM } from '@/common'
import { transformNumber } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {

const statisticeRef = ref()

const statisticsList: any = ref([
  {
    class: 'customer',
    title: '客户总数',
    current: '',
    beforeNum: '',
    unit: '个',
    key: 'orgTotal',
    reduceKey: 'lastMonthUpDownOrgTotal',
    tip: '客户为客户列表中添加的数量',
  },
  {
    class: 'device',
    title: '设备总数',
    current: '',
    beforeNum: '',
    unit: '台',
    key: 'deviceTotal',
    reduceKey: 'lastMonthUpDownDeviceTotal',
    tip: '设备数量为设备列表中添加的数量',
  },
  {
    class: 'active',
    title: '激活设备总数',
    current: '',
    beforeNum: '',
    unit: '台',
    key: 'activeDeviceTotal',
    reduceKey: 'lastMonthUpDownActiveDeviceTotal',
    tip: '激活设备数量为已经和客户绑定并且收到激活消息',
  },
  {
    class: 'msg',
    title: '上报消息总数',
    current: '',
    beforeNum: '',
    unit: '条',
    key: 'deviceUpMsgTotal',
    reduceKey: 'lastMonthUpDownDeviceUpMsgTotal',
    tip: '上报消息数量为日志中原始报文的数量',
  },
  {
    class: 'warning',
    title: '告警总数',
    current: '',
    beforeNum: '',
    unit: '条',
    key: 'alarmTotal',
    reduceKey: 'lastMonthUpDownAlarmTotal',
    tip: '告警数量为告警消息的数量',
  },
])

const querySatticsData = async () => {
  const res: any = await queryStaticsDeviceSummary()
  if (res?.code === CODE_ENUM.SUCCESS) {
    const data = res.data
    statisticsList.value = statisticsList.value.map((item: any) => {
      const { key, reduceKey } = item
      return {
        ...item,
        current: String(data[key] || 0),
        beforeNum: String(data[reduceKey] || 0),
      }
    })

    statisticeRef.value.init(data)
  }
}

querySatticsData()

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statisticsList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "statistics-item"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["icon", item.class])
          }, null, 2),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(item.title), 1),
            _createElementVNode("p", _hoisted_5, [
              _createTextVNode(_toDisplayString(_unref(transformNumber)(item.current)), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.unit), 1)
            ]),
            _createElementVNode("p", _hoisted_7, " 上月末" + _toDisplayString(_unref(transformNumber)(item.beforeNum)) + _toDisplayString(item.unit), 1)
          ]),
          _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "dark",
            content: item.tip,
            placement: "top"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 2
          }, 1032, ["content"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(CustomerMap)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(DeviceStatistice, {
          ref_key: "statisticeRef",
          ref: statisticeRef
        }, null, 512)
      ])
    ])
  ]))
}
}

})